import {
  Box,
  Icon,
  IconButton,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr
} from '@chakra-ui/react'
import { FC } from 'react'
import { MdHistory } from 'react-icons/md'

import { IListagemItem } from '@base/@types/providers/FollowUpFornecedor/ListagemProvider'

import { StatusDisparo } from '@service/followUpFornecedor'

import {
  disparoBadge,
  situacaoBadge
} from '../../../utils/followUpFornecedor/badges'

interface Props {
  filtered: IListagemItem[]
  onOpenHistorico: (item: {
    documentId: number
    productId: number
    nomeProduto: string
  }) => void
}

const ListagemTable: FC<Props> = ({ filtered, onOpenHistorico }) => (
  <Table size="sm">
    <Thead bg="gray.50" position="sticky" top={0} zIndex={1}>
      <Tr>
        <Th>Fornecedor</Th>
        <Th>Centro</Th>
        <Th>Id Produto</Th>
        <Th>Produto</Th>
        <Th>Doc.</Th>
        <Th>Data Estimada</Th>
        <Th isNumeric>A Fornecer</Th>
        <Th isNumeric>Valor R$</Th>
        <Th isNumeric>Nova Qtd.</Th>
        <Th>Nova Data</Th>
        <Th>Status Disparo</Th>
        <Th>Expiração</Th>
        <Th>Situação</Th>
        <Th>Obs. Aprovador</Th>
        <Th>Histórico</Th>
      </Tr>
    </Thead>
    <Tbody>
      {filtered.map(item => (
        <Tr key={item.id}>
          <Td>
            <Text fontWeight="500" fontSize="13px">
              {item.fornecedor}
            </Text>
          </Td>
          <Td fontSize="13px">{item.centro}</Td>
          <Td fontSize="12px" color="gray.500">
            {item.productId}
          </Td>
          <Td>
            <Text fontWeight="500" fontSize="13px">
              {item.nomeProduto}
            </Text>
          </Td>
          <Td fontSize="12px" color="gray.500">
            {item.documentId}
          </Td>
          <Td fontSize="13px">
            {new Date(item.dataEstimada).toLocaleDateString('pt-BR')}
          </Td>
          <Td isNumeric fontSize="13px">
            {item.aFornecer.toLocaleString('pt-BR')}
          </Td>
          <Td isNumeric fontSize="13px">
            {item.aFornecerReais.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            })}
          </Td>
          <Td fontSize="13px">
            {item.novaQuantidade != null ? (
              <Box display="inline-block">
                {item.quantidadeConfirmadaAtual != null && (
                  <Box
                    as="s"
                    display="inline"
                    color="gray.400"
                    fontSize="11px"
                    mr={1}
                  >
                    {item.quantidadeConfirmadaAtual}
                  </Box>
                )}
                <Box
                  as="span"
                  display="inline"
                  color="green.600"
                  fontWeight="600"
                >
                  {item.novaQuantidade}
                </Box>
              </Box>
            ) : (
              <Text color="gray.400">—</Text>
            )}
          </Td>
          <Td fontSize="13px">
            {(() => {
              if (!item.novaDataEntrega) {
                return <Text color="gray.400">—</Text>
              }
              const d = new Date(item.novaDataEntrega)
              if (isNaN(d.getTime())) {
                return <Text color="gray.400">—</Text>
              }
              const prev = item.dataConfirmadaAtual
                ? new Date(item.dataConfirmadaAtual)
                : null
              return (
                <Box display="inline-block">
                  {prev && !isNaN(prev.getTime()) && (
                    <Box
                      as="s"
                      display="inline"
                      color="gray.400"
                      fontSize="11px"
                      mr={1}
                    >
                      {prev.toLocaleDateString('pt-BR')}
                    </Box>
                  )}
                  <Box
                    as="span"
                    display="inline"
                    color="green.600"
                    fontWeight="600"
                  >
                    {d.toLocaleDateString('pt-BR')}
                  </Box>
                </Box>
              )
            })()}
          </Td>
          <Td>{disparoBadge(item.statusDisparo)}</Td>
          <Td fontSize="12px" color="gray.400">
            {new Date(item.disparoExpiresAt).toLocaleDateString('pt-BR')}
          </Td>
          <Td>
            {situacaoBadge(
              item.statusDisparo === StatusDisparo.ErroEnvio
                ? 'ErroEnvio'
                : item.situacao
            )}
          </Td>
          <Td fontSize="12px" color="gray.600" fontStyle="italic" maxW="160px">
            {item.observacaoAprovador ? (
              <Tooltip
                label={item.observacaoAprovador}
                hasArrow
                placement="top"
              >
                <Text noOfLines={1}>{item.observacaoAprovador}</Text>
              </Tooltip>
            ) : (
              <Text color="gray.300">—</Text>
            )}
          </Td>
          <Td>
            <Tooltip label="Ver histórico do par" hasArrow placement="top">
              <IconButton
                aria-label="Histórico"
                icon={<Icon as={MdHistory} boxSize={4} />}
                size="xs"
                variant="outline"
                colorScheme="purple"
                onClick={() =>
                  onOpenHistorico({
                    documentId: item.documentId,
                    productId: item.productId,
                    nomeProduto: item.nomeProduto
                  })
                }
              />
            </Tooltip>
          </Td>
        </Tr>
      ))}
    </Tbody>
  </Table>
)

export default ListagemTable
